export default __webpack_public_path__ + "static/data_port_b.53f9b0b41986997401a59b5dcc6de1dd.svg";